// Centralized barber data for Big Hit Barbershop

// 2026 professional photos
import BH from '../components/2026_Pics/BH.jpg';
import BH2 from '../components/2026_Pics/BH-2.jpg';
import BH3 from '../components/2026_Pics/BH-3.jpg';
import BH4 from '../components/2026_Pics/BH-4.jpg';
import BH7 from '../components/2026_Pics/BH-7.jpg';
import BH8 from '../components/2026_Pics/BH-8.jpg';
import BH9 from '../components/2026_Pics/BH-9.jpg';
import BH10 from '../components/2026_Pics/BH-10.jpg';
import BH11 from '../components/2026_Pics/BH-11.jpg';
import BH13 from '../components/2026_Pics/BH-13.jpg';
import BH14 from '../components/2026_Pics/BH-14.jpg';
import BH15 from '../components/2026_Pics/BH-15.jpg';
import BH19 from '../components/2026_Pics/BH-19.jpg';
import BH20 from '../components/2026_Pics/BH-20.jpg';
import BH21 from '../components/2026_Pics/BH-21.jpg';
import BH22 from '../components/2026_Pics/BH-22.jpg';
import BH23 from '../components/2026_Pics/BH-23.jpg';
import BH24 from '../components/2026_Pics/BH-24.jpg';
import BH26 from '../components/2026_Pics/BH-26.jpg';
import BH27 from '../components/2026_Pics/BH-27.jpg';
import BH28 from '../components/2026_Pics/BH-28.jpg';
import BH29 from '../components/2026_Pics/BH-29.jpg';
import BH30 from '../components/2026_Pics/BH-30.jpg';
import Rome from '../components/barbers/rome.jpg';


// Gallery images
import Shawn1 from '../components/haircuts/shawn1.jpg';
import Shawn2 from '../components/haircuts/shawn2.jpg';
import Shawn3 from '../components/haircuts/shawn3.jpg';
import Shawn4 from '../components/haircuts/shawn4.jpg';
import Shawn5 from '../components/haircuts/shawn5.jpg';
import Nick1 from '../components/haircuts/nick1.jpg';
import Nick2 from '../components/haircuts/nick2.jpg';
import Nick3 from '../components/haircuts/nick3.jpg';
import Nick4 from '../components/haircuts/nick4.jpg';
import Nick5 from '../components/haircuts/nick5.jpg';
import Adam1 from '../components/haircuts/adam1.jpg';
import Adam2 from '../components/haircuts/adam2.jpg';
import Adam3 from '../components/haircuts/adam3.jpg';
import Adam4 from '../components/haircuts/adam4.jpg';
import Adam5 from '../components/haircuts/adam5.jpg';
import Adam10 from '../components/cutz/adam10.jpg';
import Adam12 from '../components/cutz/adam12.jpg';
import Adam13 from '../components/cutz/adam13.jpg';
import Adam14 from '../components/cutz/adam14.jpg';
import Nick10 from '../components/cutz/nick10.jpg';
import Nick12 from '../components/cutz/nick12.jpg';
import Nick13 from '../components/cutz/nick13.jpg';
import Nick14 from '../components/cutz/nick14.jpg';
import Shawn10 from '../components/cutz/shawn10.jpg';
import Shawn12 from '../components/cutz/shawn12.jpg';
import Shawn13 from '../components/cutz/shawn13.jpg';
import Shawn14 from '../components/cutz/shawn14.jpg';
import Shawn15 from '../components/cutz/shawn15.jpg';
import Shawn16 from '../components/cutz/shawn16.jpg';
import Shawn17 from '../components/cutz/shawn17.jpg';
import Shawn18 from '../components/cutz/shawn18.jpg';
import Shawn19 from '../components/cutz/shawn19.jpg';

// Booking URLs
export const bookingUrls = {
    Shawn: 'https://getsquire.com/booking/book/big-hit-barbershop-las-vegas-las-vegas/barber/shawn-lievense/services',
    Nick: 'https://getsquire.com/booking/book/big-hit-barbershop-las-vegas-las-vegas/barber/nick-excell/services',
    Adam: 'https://getsquire.com/booking/book/big-hit-barbershop-las-vegas-las-vegas/barber/adam-patino/services',
    Rome: 'https://getsquire.com/booking/book/big-hit-barbershop-las-vegas-las-vegas/barber/rome-mendez/services',
};

// Las Vegas barbers
export const lasVegasBarbers = [
    {
        name: 'Shawn L.',
        title: 'Owner & Barber',
        imgSrc: BH,
        instagram: 'mr_big_hitz',
        appointment: bookingUrls.Shawn
    },
    {
        name: 'Nick E.',
        title: 'Barber',
        imgSrc: BH4,
        imgPosition: '65% center',
        instagram: 'nickcutz_',
        appointment: bookingUrls.Nick
    },
    {
        name: 'Adam P.',
        title: 'Barber',
        imgSrc: BH2,
        instagram: 'cutzby_patino',
        appointment: bookingUrls.Adam
    },
    {
        name: 'Rome M.',
        title: 'Luxury Barber',
        imgSrc: Rome,
        imgPosition: 'center 15%',
        instagram: 'precisionbyrome',
        appointment: bookingUrls.Rome
    },
];

// Kenosha booking (Booksy — no per-barber booking links available, all barbers share this page)
export const kenoshaBookingUrl = 'https://booksy.com/en-us/408993_big-hit-barbershop_barber-shop_39844_kenosha';

// Kenosha barbers
export const kenoshaBarbers = [
    { name: 'Jess', title: 'Barber', instagram: '_jessthebarberxo', appointment: kenoshaBookingUrl },
    { name: "De'Eric", title: 'Barber', appointment: kenoshaBookingUrl },
    { name: 'Mike (Lorenzo)', title: 'Barber', instagram: 'lorenzo_dabarber', appointment: kenoshaBookingUrl },
    { name: 'Lyndsey C.', title: 'Barber', instagram: 'lyndsey_bighit', appointment: kenoshaBookingUrl },
];

// Gallery images with descriptive alt text
export const galleryImages = [
    { src: BH, barber: 'BH', alt: 'Big Hit Barbershop - photo 1' },
    { src: BH2, barber: 'BH', alt: 'Big Hit Barbershop - photo 2' },
    { src: BH3, barber: 'BH', alt: 'Big Hit Barbershop - photo 3' },
    { src: BH4, barber: 'BH', alt: 'Big Hit Barbershop - photo 4' },
    { src: BH7, barber: 'BH', alt: 'Big Hit Barbershop - photo 7' },
    { src: BH8, barber: 'BH', alt: 'Big Hit Barbershop - photo 8' },
    { src: BH9, barber: 'BH', alt: 'Big Hit Barbershop - photo 9' },
    { src: BH10, barber: 'BH', alt: 'Big Hit Barbershop - photo 10' },
    { src: BH11, barber: 'BH', alt: 'Big Hit Barbershop - photo 11' },
    { src: BH13, barber: 'BH', alt: 'Big Hit Barbershop - photo 13' },
    { src: BH14, barber: 'BH', alt: 'Big Hit Barbershop - photo 14' },
    { src: BH15, barber: 'BH', alt: 'Big Hit Barbershop - photo 15' },
    { src: BH19, barber: 'BH', alt: 'Big Hit Barbershop - photo 19' },
    { src: BH20, barber: 'BH', alt: 'Big Hit Barbershop - photo 20' },
    { src: BH21, barber: 'BH', alt: 'Big Hit Barbershop - photo 21' },
    { src: BH22, barber: 'BH', alt: 'Big Hit Barbershop - photo 22' },
    { src: BH23, barber: 'BH', alt: 'Big Hit Barbershop - photo 23' },
    { src: BH24, barber: 'BH', alt: 'Big Hit Barbershop - photo 24' },
    { src: BH26, barber: 'BH', alt: 'Big Hit Barbershop - photo 26' },
    { src: BH27, barber: 'BH', alt: 'Big Hit Barbershop - photo 27' },
    { src: BH28, barber: 'BH', alt: 'Big Hit Barbershop - photo 28' },
    { src: BH29, barber: 'BH', alt: 'Big Hit Barbershop - photo 29' },
    { src: BH30, barber: 'BH', alt: 'Big Hit Barbershop - photo 30' },

    { src: Shawn1, barber: 'Shawn', alt: 'Haircut by Shawn - style 1' },
    { src: Nick1, barber: 'Nick', alt: 'Haircut by Nick - style 1' },
    { src: Adam1, barber: 'Adam', alt: 'Haircut by Adam - style 1' },
    { src: Shawn10, barber: 'Shawn', alt: 'Haircut by Shawn - style 2' },
    { src: Nick10, barber: 'Nick', alt: 'Haircut by Nick - style 2' },
    { src: Adam10, barber: 'Adam', alt: 'Haircut by Adam - style 2' },
    { src: Shawn2, barber: 'Shawn', alt: 'Haircut by Shawn - style 3' },
    { src: Nick2, barber: 'Nick', alt: 'Haircut by Nick - style 3' },
    { src: Adam2, barber: 'Adam', alt: 'Haircut by Adam - style 3' },
    { src: Shawn12, barber: 'Shawn', alt: 'Haircut by Shawn - style 4' },
    { src: Nick12, barber: 'Nick', alt: 'Haircut by Nick - style 4' },
    { src: Adam12, barber: 'Adam', alt: 'Haircut by Adam - style 4' },
    { src: Shawn3, barber: 'Shawn', alt: 'Haircut by Shawn - style 5' },
    { src: Nick3, barber: 'Nick', alt: 'Haircut by Nick - style 5' },
    { src: Adam3, barber: 'Adam', alt: 'Haircut by Adam - style 5' },
    { src: Shawn13, barber: 'Shawn', alt: 'Haircut by Shawn - style 6' },
    { src: Nick13, barber: 'Nick', alt: 'Haircut by Nick - style 6' },
    { src: Adam13, barber: 'Adam', alt: 'Haircut by Adam - style 6' },
    { src: Shawn4, barber: 'Shawn', alt: 'Haircut by Shawn - style 7' },
    { src: Nick4, barber: 'Nick', alt: 'Haircut by Nick - style 7' },
    { src: Adam4, barber: 'Adam', alt: 'Haircut by Adam - style 7' },
    { src: Shawn14, barber: 'Shawn', alt: 'Haircut by Shawn - style 8' },
    { src: Nick14, barber: 'Nick', alt: 'Haircut by Nick - style 8' },
    { src: Adam14, barber: 'Adam', alt: 'Haircut by Adam - style 8' },
    { src: Shawn5, barber: 'Shawn', alt: 'Haircut by Shawn - style 9' },
    { src: Nick5, barber: 'Nick', alt: 'Haircut by Nick - style 9' },
    { src: Adam5, barber: 'Adam', alt: 'Haircut by Adam - style 9' },
    { src: Shawn15, barber: 'Shawn', alt: 'Haircut by Shawn - style 10' },
    { src: Shawn16, barber: 'Shawn', alt: 'Haircut by Shawn - style 11' },
    { src: Shawn17, barber: 'Shawn', alt: 'Haircut by Shawn - style 12' },
    { src: Shawn18, barber: 'Shawn', alt: 'Haircut by Shawn - style 13' },
    { src: Shawn19, barber: 'Shawn', alt: 'Haircut by Shawn - style 14' },
]